import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable, Subject, zip } from 'rxjs';

import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable()
export class ContextBridgeService {
  private notificationSubject = new Subject<void>(); // Notifies all subscribers
  private dataSubjects: BehaviorSubject<any>[] = []; // Subjects for collecting data from each component

  constructor() {}

  // This function will be called from Component A and trigger notifications
  async queryData(): Promise<any[]> {
    this.notificationSubject.next();

    // Wait for all components to send data using zip and convert the result to a promise
    return await firstValueFrom(zip(...this.dataSubjects));
  }

  // This function is used by components to subscribe to the notification
  onNotify(): Observable<void> {
    return this.notificationSubject.asObservable();
  }

  // Components call this function to register themselves and provide a subject for sending data
  registerComponent(): Subject<any> {
    const dataSubject = new BehaviorSubject<any>(null); // A BehaviorSubject to handle data from the component
    this.dataSubjects.push(dataSubject); // Add to the collection of subjects
    return dataSubject; // Return the subject so component can send data
  }
}
